// src/axios.js
import axios from 'axios';

const instance = axios.create({
  // baseURL: 'http://10.8.0.89:20790', // 访问服务器api的地址
  // baseURL: 'http://167.99.4.82:20781', // 访问服务器api的地址
  // baseURL: 'https://easynoteai.online', // 访问服务器api的地址
  baseURL: 'https://www.easynoteai.com', // 访问服务器api的地址
  timeout: 30000, // 设置超时时间
  // withCredentials: true, // 允许携带cookies
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 可以在这里添加token等认证信息
    return config;
  },
  error => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.error('Response error:', error);
    if (error.response) {
      // 服务器响应了错误状态码
      console.error('Error status:', error.response.status);
      console.error('Error data:', error.response.data);
    } else if (error.request) {
      // 请求已发出但没有收到响应
      console.error('No response received:', error.request);
    } else {
      // 其他错误
      console.error('Error message:', error.message);
    }
    return Promise.reject(error);
  }
);

export default instance;
